import { Button, Text } from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';
import { useContext } from 'react';
import { ChatContext } from '../context/ChatContext';

const ResetChat = () => {
  const { resetChat, promtRef } = useContext(ChatContext)

  const onConfirmReset = () => {
    openConfirmModal({
      zIndex: 9999,
      title: 'Reset Chat',
      centered: true,
      children: (
        <Text size="sm">
          All chat history will be deleted.
        </Text>
      ),
      labels: { confirm: 'Reset Chat', cancel: 'Cancel' },
      onCancel: () => {},
      onConfirm: resetChat,
    })
  }

  return (
    <>
      <Button
        variant="gradient"
        size="xs"
        style={{ marginRight: 8 }}
        onClick={onConfirmReset}
      >
        Reset
      </Button>
    </>
  )
}

export default ResetChat
